import React from "react"

import { PropertyList } from "shared/ui/property-list/PropertyList"

import { useProductPositionFormProductInformationContext } from "../contexts/ProductPositionFormProductInformationContext"

export const ProductPositionFormConfigurationTab = React.memo(() => {
  const { productInformation, isLoadingProductInformation } =
    useProductPositionFormProductInformationContext()

  return (
    <div className="product-position-form__tab-content product-position-form__tab-content--configuration">
      <PropertyList
        list={productInformation?.attributes ?? []}
        isLoading={isLoadingProductInformation}
      />
    </div>
  )
})
